import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime-corejs3/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _Object$values from "@babel/runtime-corejs3/core-js-stable/object/values";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";

var _context, _context2, _dec, _class, _class2, _temp;

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context4; _forEachInstanceProperty(_context4 = ownKeys(source, true)).call(_context4, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context5; _forEachInstanceProperty(_context5 = ownKeys(source)).call(_context5, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { Component } from 'react';
import types from 'prop-types';
import { styled, StyleSheet } from '@rexlabs/styling';
import { withLayout } from './layout-context';
import { get, omit } from 'lodash';
var flexTypes = {
  flexDirection: types.string,
  flexWrap: types.string,
  alignItems: types.string,
  alignContent: types.string,
  justifyContent: types.string,
  flexShrink: types.oneOfType([types.string, types.number]),
  flex: types.oneOfType([types.string, types.number, types.bool]),
  flexAuto: types.bool,
  flexNone: types.bool
};
var aliases = {
  p: 'padding',
  pt: 'paddingTop',
  pr: 'paddingRight',
  pb: 'paddingBottom',
  pl: 'paddingLeft',
  m: 'margin',
  mt: 'marginTop',
  mr: 'marginRight',
  mb: 'marginBottom',
  ml: 'marginLeft',
  width: 'width',
  height: 'height',
  w: 'width',
  h: 'height'
};

var flexProps = _Object$keys(flexTypes);

var spacingProps = _concatInstanceProperty(_context = []).call(_context, _toConsumableArray(_Object$keys(aliases)), _toConsumableArray(_Object$values(aliases)));

var styleProps = _concatInstanceProperty(_context2 = []).call(_context2, _toConsumableArray(flexProps), _toConsumableArray(spacingProps));

var spacingTypes = _reduceInstanceProperty(spacingProps).call(spacingProps, function (acc, spacingProp) {
  return _objectSpread({}, acc, _defineProperty({}, spacingProp, types.oneOfType([types.string, types.number, types.arrayOf(types.string)])));
}, {});

var defaultStyles = StyleSheet({
  container: {
    boxSizing: 'border-box'
  }
});
var Box = (_dec = styled(defaultStyles), withLayout(_class = _dec(_class = (_temp = _class2 =
/*#__PURE__*/
function (_Component) {
  _inherits(Box, _Component);

  function Box() {
    var _getPrototypeOf2, _context3;

    var _this;

    _classCallCheck(this, Box);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Box)).call.apply(_getPrototypeOf2, _concatInstanceProperty(_context3 = [this]).call(_context3, args)));

    _defineProperty(_assertThisInitialized(_this), "styleReducer", function (acc, propName) {
      var _this$props = _this.props,
          layout = _this$props.layout,
          props = _objectWithoutProperties(_this$props, ["layout"]);

      var value = get(layout, props[propName]) || props[propName];
      if (!value) return acc;
      acc[aliases[propName] || propName] = value;
      return acc;
    });

    _defineProperty(_assertThisInitialized(_this), "mapStyles", function () {
      var base = _this.isFlex() ? {
        display: 'flex'
      } : {};
      return _reduceInstanceProperty(styleProps).call(styleProps, _this.styleReducer, base);
    });

    _defineProperty(_assertThisInitialized(_this), "isFlex", function () {
      return !!_findInstanceProperty(flexProps).call(flexProps, function (flexType) {
        return _this.props[flexType];
      });
    });

    _defineProperty(_assertThisInitialized(_this), "cleanupProps", function (props) {
      return omit(props, styleProps);
    });

    return _this;
  }

  _createClass(Box, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          Container = _this$props2.Container,
          layout = _this$props2.layout,
          s = _this$props2.styles,
          props = _objectWithoutProperties(_this$props2, ["children", "Container", "layout", "styles"]);

      return React.createElement(Container, _extends({}, this.cleanupProps(props), s.with('container')({
        style: props.style,
        className: props.className
      }, this.mapStyles())), children);
    }
  }]);

  return Box;
}(Component), _defineProperty(_class2, "propTypes", _objectSpread({}, flexTypes, {}, spacingTypes, {
  Container: types.elementType,
  children: types.node
})), _defineProperty(_class2, "defaultProps", {
  Container: 'div'
}), _temp)) || _class) || _class);
export default Box;